/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseCHOpenIcon24Regular = forwardRef('ArrowCollapseCHOpenIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M2.692 13.68a2.375 2.375 0 0 1 0-3.36l5.69-5.689A.875.875 0 0 1 9.619 5.87l-5.69 5.689a.625.625 0 0 0 0 .884l5.69 5.689a.875.875 0 1 1-1.237 1.237l-5.69-5.689Z" }),
        React.createElement("path", { d: "M21.308 13.68a2.375 2.375 0 0 0 0-3.36l-5.69-5.689a.875.875 0 1 0-1.236 1.238l5.689 5.689a.625.625 0 0 1 0 .884l-5.69 5.689a.875.875 0 1 0 1.238 1.237l5.69-5.689Z" })));
});
